import { ofType } from 'redux-observable';
import { catchError, of, switchMap } from 'rxjs';
import { LocationType } from 'features/searchResultsFacets';
import locationContentSlice from './slice';
import housingProductLocationContentCommand from '../services/commands';
import getOnPageContentRequest$ from '../apis/getHousingProductLocationContent';

const actions = locationContentSlice.actions;

const command = housingProductLocationContentCommand();

/**
 * This is an epic that listens for a fetch action, retrieves data using a payload from the state,
 * and dispatches either a fetchFulfilled or fetchError action based on the result.
 * @param action$ - parameter is an observable stream of actions dispatched in the
 * application. It represents the actions that are being listened to by the epic.
 * @param state$ - is an observable stream that emits the current state of the
 * application. It is typically used to access the current state values and make decisions based on
 * them.
 */
const fetchHousingProductLocationContentEpic = (action$, state$) =>
  action$.pipe(
    ofType(actions.fetch.type),
    switchMap(() => {
      const selectHousingProduct = command.selectHousingProduct();
      const payload = selectHousingProduct(state$.value);
      return getOnPageContentRequest$(payload).pipe(
        switchMap((data) => {
          const { locationType } = payload?.searchLocationCommand?.searchParameters?.location || {};
          const isState = locationType === LocationType.State.toString();
          return of(isState ? actions.fetchFulfilledState(data) : actions.fetchFulfilled(data));
        }),
        catchError((error) => of(actions.fetchError(error)))
      );
    })
  );

export default fetchHousingProductLocationContentEpic;
